module.exports = {"data":{"site":{"siteMetadata":{"title":"Lights Out - Gatsby App","description":"Lights Out puzzle in Gatsby react","keywords":"lights-out, gatsby, react, material-ui","version":"0.11.1"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 159
// module chunks = 60335399758886 114276838955818